/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import DataTables from '../../DataTable/DataTables'
// import 'rc-tooltip/assets/bootstrap.css'
import Tooltip from 'rc-tooltip'
import {DataTable, DataTableFilterMeta} from 'primereact/datatable'
import {Column, ColumnFilterElementTemplateOptions} from 'primereact/column'
import {Tag} from 'primereact/tag'
import {ConfirmDialog, confirmDialog} from 'primereact/confirmdialog'
import {Button} from 'primereact/button'
import data from '../dummyData.json'
import InquiryDataTableAndActions from './InquiryDataTableAndActions'
// const subjectList = uniq(map(assignmentTableBody, 'subject'))

const titleBodyTemplate = (value) => {
  const trimmedData = {name: value.inquiryName}
  return (
    <div className='d-flex align-items-center justify-content-center gap-2'>
      {/* <img alt={trimmedData.name} src={trimmedData.image} width='32' /> */}
      <span className='col'>{trimmedData.name}</span>
    </div>
  )
}

const applicationFormStatusBodyTemplate = (value) => {
  const trimmedData = {name: value.applicationFormStatus}
  return (
    <div className='d-flex align-items-center justify-content-center'>
      <Tag
        className='col-6'
        value={trimmedData.name}
        severity={
          trimmedData.name === 'pending'
            ? 'warning'
            : trimmedData.name === 'rejected'
            ? 'danger'
            : 'success'
        }
      />
    </div>
  )
}
const documentUploadStatusBodyTemplate = (value) => {
  const trimmedData = {name: value.documentUploadStatus}
  return (
    <div className='d-flex align-items-center justify-content-center gap-2'>
      <Tag
        className='col-6'
        value={trimmedData.name}
        severity={
          trimmedData.name === 'pending'
            ? 'warning'
            : trimmedData.name === 'rejected'
            ? 'danger'
            : 'success'
        }
      />
    </div>
  )
}
const applicationReviewStatusBodyTemplate = (value) => {
  const trimmedData = {name: value.applicationReviewStatus}
  return (
    <div className='d-flex align-items-center justify-content-center gap-2'>
      <Tag
        className='col-6'
        value={trimmedData.name}
        severity={
          trimmedData.name === 'pending'
            ? 'warning'
            : trimmedData.name === 'rejected'
            ? 'danger'
            : 'success'
        }
      />
    </div>
  )
}
const interviewStatusBodyTemplate = (value) => {
  const trimmedData = {name: value.interviewStatus}
  return (
    <div className='d-flex align-items-center justify-content-center gap-2'>
      <Tag
        className='col-6'
        value={trimmedData.name}
        severity={
          trimmedData.name === 'pending'
            ? 'warning'
            : trimmedData.name === 'rejected'
            ? 'danger'
            : 'success'
        }
      />
    </div>
  )
}

const AdmissionBody = () => {
  // const accept = () => {}
  // const reject = () => {}
  // const confirm = (header, message) => {
  //   confirmDialog({
  //     message,
  //     header,
  //     position: 'top',
  //     acceptLabel: header === 'Accept Application' ? 'Accept' : 'Reject',
  //     acceptClassName: `${
  //       header === 'Accept Application' ? 'p-button-info' : 'p-button-danger'
  //     } rounded-pill px-8`,
  //     accept,
  //     reject,
  //   })
  // }
  // const inquiryActionBodyTemplate = (value) => {
  //   return (
  //     <div className='d-flex justify-content-center align-items-center gap-2'>
  //       <Button
  //         label='review'
  //         rounded
  //         outlined
  //         severity='success'
  //         className='px-8'
  //         style={{
  //           borderRadius: '2rem',
  //         }}
  //       />
  //       <Button
  //         label='accept'
  //         rounded
  //         severity='success'
  //         className='px-8'
  //         style={{
  //           borderRadius: '2rem',
  //         }}
  //         onClick={() =>
  //           confirm(
  //             'Accept Application',
  //             'Are you sure you want to approve the application and confirm that the applicant has completed all required processes?'
  //           )
  //         }
  //       />
  //       <Button
  //         label='reject'
  //         rounded
  //         severity='danger'
  //         className='px-8'
  //         style={{
  //           borderRadius: '2rem',
  //         }}
  //         onClick={() =>
  //           confirm(
  //             'Reject Application',
  //             'Are you sure you want to reject this application? Once rejected, the decision cannot be undone, and a new application will need to be initiated.'
  //           )
  //         }
  //       />
  //       {/* <button
  //         data-pr-tooltip='Delete Blog'
  //         className={`btn delete-blog${row.id} p-0`}
  //         onClick={() => {
  //           Swal.fire({
  //             title: 'Confirm deletion?',
  //             showDenyButton: false,
  //             showCancelButton: true,
  //             confirmButtonText:
  //               "<i className='ki-duotone ki-double-check  fs-1'> <span className='path1'></span><span className='path2'></span> <span className='path3'></span></i> Confirm",
  //             confirmButtonColor: '#009EF7',
  //             cancelButtonText:
  //               '<i class="ki-duotone ki-abstract-11  text-white fs-3"><span class="path1"></span><span class="path2"></span></i> Cancel',
  //           }).then((result) => {

  //             if (result.isConfirmed) {

  //             } else if (result.isDenied) {
  //               Swal.fire('Record is not deleted', '', 'error')
  //             }
  //           })
  //         }}
  //       >
  //         <CancelIcon />
  //       </button> */}
  //     </div>
  //   )
  // }
  const rejectedApplicationActionBodyTemplate = (value) => {
    const buttonValue =
      value.applicationFormStatus === 'done' &&
      value.documentUploadStatus === 'done' &&
      value.applicationReviewStatus === 'done' &&
      value.interviewStatus === 'done'
        ? 'view'
        : 'review'
    return (
      <div className='d-flex justify-content-center align-items-center gap-2'>
        <Button
          label={buttonValue}
          rounded
          outlined
          severity='success'
          className='px-8'
          style={{
            borderRadius: '2rem',
          }}
        />
      </div>
    )
  }
  // const inquiryColumns = [
  //   <Column
  //     field='inquiryName'
  //     body={titleBodyTemplate}
  //     // filterPlaceholder='Search by title'
  //     showFilterMenu={false}
  //     alignHeader='center'
  //     // filter
  //     sortable
  //     sortField='inquiryName'
  //     frozen
  //     header='Name'
  //     key='inquiryName'
  //   />,

  //   <Column
  //     field='inquiryDate'
  //     align='center'
  //     alignHeader='center'
  //     sortable
  //     className='col-2'
  //     header='Inquiry Date'
  //     key='date'
  //   />,

  //   <Column
  //     field='applicationFormStatus'
  //     // filterField='author'
  //     sortField='applicationFormStatus'
  //     alignHeader='center'
  //     sortable
  //     // filter
  //     showFilterMenu={false}
  //     showClearButton={false}
  //     // filterElement={authorFilterRowTemplate}
  //     header='Application Form'
  //     body={applicationFormStatusBodyTemplate}
  //     key='applicationFormStatus'
  //   />,
  //   <Column
  //     field='documentUploadStatus'
  //     // filterField='author'
  //     sortField='documentUploadStatus'
  //     alignHeader='center'
  //     sortable
  //     // filter
  //     showFilterMenu={false}
  //     showClearButton={false}
  //     // filterElement={authorFilterRowTemplate}
  //     header='Document Upload'
  //     body={documentUploadStatusBodyTemplate}
  //     key='documentUploadStatus'
  //   />,
  //   <Column
  //     field='applicationReviewStatus'
  //     // filterField='author'
  //     sortField='applicationReviewStatus'
  //     alignHeader='center'
  //     sortable
  //     // filter
  //     showFilterMenu={false}
  //     showClearButton={false}
  //     // filterElement={authorFilterRowTemplate}
  //     header='Application Review'
  //     body={applicationReviewStatusBodyTemplate}
  //     key='applicationReviewStatus'
  //   />,
  //   <Column
  //     field='interviewStatus'
  //     // filterField='author'
  //     sortField='interviewStatus'
  //     alignHeader='center'
  //     sortable
  //     // filter
  //     showFilterMenu={false}
  //     showClearButton={false}
  //     // filterElement={authorFilterRowTemplate}
  //     header='Interview/Test'
  //     body={interviewStatusBodyTemplate}
  //     key='interviewStatus'
  //   />,

  //   <Column
  //     header='Actions/Status'
  //     alignHeader='center'
  //     // headerClassName=''
  //     body={inquiryActionBodyTemplate}
  //     exportable={false}
  //     // style={{minWidth: '10rem'}}
  //     key='actions'
  //   />,
  // ]
  const rejectedApplicationColumns = [
    <Column
      field='inquiryName'
      body={titleBodyTemplate}
      // filterPlaceholder='Search by title'
      showFilterMenu={false}
      alignHeader='center'
      // filter
      sortable
      sortField='inquiryName'
      frozen
      header='Name'
      key='inquiryName'
    />,

    <Column
      field='inquiryDate'
      align='center'
      alignHeader='center'
      sortable
      header='Inquiry Date'
      key='date'
    />,

    <Column
      field='applicationFormStatus'
      // filterField='author'
      sortField='applicationFormStatus'
      alignHeader='center'
      sortable
      // filter
      showFilterMenu={false}
      showClearButton={false}
      // filterElement={authorFilterRowTemplate}
      header='Application Form'
      body={applicationFormStatusBodyTemplate}
      key='applicationFormStatus'
    />,
    <Column
      field='documentUploadStatus'
      // filterField='author'
      sortField='documentUploadStatus'
      alignHeader='center'
      sortable
      // filter
      showFilterMenu={false}
      showClearButton={false}
      // filterElement={authorFilterRowTemplate}
      header='Document Upload'
      body={documentUploadStatusBodyTemplate}
      key='documentUploadStatus'
    />,
    <Column
      field='applicationReviewStatus'
      // filterField='author'
      sortField='applicationReviewStatus'
      alignHeader='center'
      sortable
      // filter
      showFilterMenu={false}
      showClearButton={false}
      // filterElement={authorFilterRowTemplate}
      header='Application Review'
      body={applicationReviewStatusBodyTemplate}
      key='applicationReviewStatus'
    />,
    <Column
      field='interviewStatus'
      // filterField='author'
      sortField='interviewStatus'
      alignHeader='center'
      sortable
      // filter
      showFilterMenu={false}
      showClearButton={false}
      // filterElement={authorFilterRowTemplate}
      header='Interview/Test'
      body={interviewStatusBodyTemplate}
      key='interviewStatus'
    />,

    <Column
      header='Actions/Status'
      alignHeader='center'
      // headerClassName=''
      body={rejectedApplicationActionBodyTemplate}
      exportable={false}
      // style={{minWidth: '10rem'}}
      key='actions'
    />,
  ]

  return (
    <>
      <div className='card rounded-bottom-0'>
        <div className='card-header'>
          <div className='card-title'>Inquiry</div>
        </div>
        {/* begin::Body */}
        <div className='card-body'>
          <InquiryDataTableAndActions />
        </div>
        {/* begin::Body */}
      </div>

      <div className='card rounded-top-0'>
        <div className='card-header'>
          <div className='card-title'>Rejected Applications</div>
        </div>
        <div className='card-body'>
          <div className='row'>
            <DataTable
              value={data.rejectedApplicationTableValues}
              showGridlines
              paginator
              rows={20}
              rowsPerPageOptions={[1, 2, 5, 10, 20, 25, 50, 100]}
              size='normal'
              tableStyle={{minWidth: '50rem'}}
              // filters={tableFilters}
              removableSort
              emptyMessage='No Rejected Applicants have been added for the selected filters.'
              paginatorTemplate='FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown'
              currentPageReportTemplate='Showing {first} to {last} of {totalRecords} Rejected Applicants'
              scrollable
              // filterDisplay='row'
            >
              {rejectedApplicationColumns}
            </DataTable>
          </div>
        </div>
      </div>
    </>
  )
}

export {AdmissionBody}
